import React, { useState, useEffect } from 'react';

import Navbar from '../Components/HomePage/Navbar';
import Footer from '../Components/HomePage/Footer';
import AmazonProductsSection from '../Components/HomePage/AmazonProductCard';

import CartDrawer from '../Components/Cart/CartDrawer';

function ProductsIndex() {

  // ==========================================
  // CART STATE
  // ==========================================
  const [isCartOpen, setIsCartOpen] =
    useState(false);

  const [cartItems, setCartItems] =
    useState(() => {

      const savedCart =
        localStorage.getItem('cart');

      return savedCart
        ? JSON.parse(savedCart)
        : [];
    });

  // ==========================================
  // SAVE CART
  // ==========================================
  useEffect(() => {

    localStorage.setItem(
      'cart',
      JSON.stringify(cartItems)
    );

  }, [cartItems]);

  // ==========================================
  // ADD TO CART
  // ==========================================
  const handleAddToCart = (product) => {

    setCartItems((prev) => {

      const uniqueId =
        `${product.id}-${product.price}`;

      const existingItem =
        prev.find(
          (item) =>
            item.uniqueId === uniqueId
        );

      // EXISTING ITEM
      if (existingItem) {

        return prev.map((item) =>

          item.uniqueId === uniqueId
            ? {
                ...item,

                qty:
                  Number(item.qty) +
                  Number(
                    product.qty || 1
                  ),
              }
            : item
        );
      }

      // NEW ITEM
      return [
        ...prev,
        {
          ...product,

          uniqueId,

          qty: Number(
            product.qty || 1
          ),

          price: Number(
            product.price
          ),
        },
      ];
    });

    setIsCartOpen(true);
  };

  // ==========================================
  // REMOVE ITEM
  // ==========================================
  const removeFromCart = (
    uniqueId
  ) => {

    setCartItems((prev) =>

      prev.filter(
        (item) =>
          item.uniqueId !== uniqueId
      )
    );
  };

  // ==========================================
  // UPDATE QTY
  // ==========================================
  const updateQty = (
    uniqueId,
    delta
  ) => {

    setCartItems((prev) =>

      prev.map((item) => {

        if (
          item.uniqueId === uniqueId
        ) {

          const newQty =
            Number(item.qty) +
            delta;

          return {
            ...item,

            qty:
              newQty > 0
                ? newQty
                : 1,
          };
        }

        return item;
      })
    );
  };

  // ==========================================
  // CHECKOUT
  // ==========================================
  const handleCheckout = () => {

    if (cartItems.length === 0)
      return;

    localStorage.setItem(
      'cart_access',
      'true'
    );

    window.location.href =
      '/PaymentIndex';
  };

  return (
    <div className="bg-white overflow-x-hidden">

      {/* NAVBAR */}
      <Navbar />
      <div
       className='mt-16'>
        {/* PRODUCTS */}
      <AmazonProductsSection
        onAddToCart={
          handleAddToCart
        }
      />
      </div>
      

      {/* FOOTER */}
      <Footer />

      {/* CART */}
      <CartDrawer
        isOpen={isCartOpen}
        setIsOpen={setIsCartOpen}
        cartItems={cartItems}
        removeFromCart={
          removeFromCart
        }
        updateQty={updateQty}
        handleCheckout={
          handleCheckout
        }
      />
    </div>
  );
}

export default ProductsIndex;